import PropTypes from 'prop-types'
import { Editor } from '@tinymce/tinymce-react'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'
import { useTranslation } from 'react-i18next'
import useWelcomeMessage from './useWelcomeMessage'
import SDNotification from '@/shared/components/SDComponents/SDNotification'
import useImportScript from '@/shared/hooks/useImportScript'

const WelcomeMessage = ({ data, setData }) => {
  const {
    editorRef,
    isEditingWelcomeText,
    setIsEditingWelcomeText,
    saveWelcomeMessage,
    isLoading,
    errorMessage,
    error,
    tinymceKey,
  } = useWelcomeMessage(data, setData)
  const { t } = useTranslation()
  const { loadScript } = useImportScript()

  if (!isEditingWelcomeText) {
    loadScript('//embed.typeform.com/next/embed.js', false, true)
    return (
      <>
        <div dangerouslySetInnerHTML={{ __html: data.welcomeMessage }} />
        {data.isAdmin && <SDButton onClick={() => setIsEditingWelcomeText(true)}>{t('common:edit')}</SDButton>}
        {error === false && <SDNotification type={'positive'}>{t('home:welcome_message.save_ok')}</SDNotification>}
      </>
    )
  }

  return (
    <>
      <Editor
        apiKey={tinymceKey}
        initialValue={data.welcomeMessage}
        onInit={(evt, editor) => (editorRef.current = editor)}
        init={{
          height: 250,
          plugins: [
            'advlist',
            'autolink',
            'lists',
            'link',
            'image',
            'charmap',
            'preview',
            'anchor',
            'searchreplace',
            'visualblocks',
            'code',
            'fullscreen',
            'insertdatetime',
            'media',
            'table',
            'code',
            'wordcount',
          ],
          toolbar:
            'undo redo | formatselect | ' +
            'bold italic backcolor | alignleft aligncenter ' +
            'alignright alignjustify | bullist numlist outdent indent | ' +
            'removeformat | help',
        }}
      />
      <SDButton onClick={() => setIsEditingWelcomeText(false)}>{t('common:cancel')}</SDButton>
      <SDButton onClick={saveWelcomeMessage} isLoading={isLoading}>
        {t('common:save')}
      </SDButton>
      {error && errorMessage && (
        <SDNotification type={'warning'}>
          {t('home:welcome_message.save_ko')}
          {errorMessage}
        </SDNotification>
      )}
    </>
  )
}

WelcomeMessage.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.func,
}

export default WelcomeMessage
